import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { useSelector } from 'react-redux';
import { selectActiveScene } from 'redux/db/reducers';
import { canEdit } from 'redux/db/util';
import { displayViewOnlyModal, startSceneChatDraft } from 'redux/mode/util';
import { RootReducer } from 'redux/reducers';

const SceneNewChatAction = () => {
	const activeScene = useSelector((r: RootReducer) =>
		selectActiveScene(r.db, r.mode.activeSceneId)
	);

	const onClick = () => {
		if (!activeScene) return;

		if (!canEdit(activeScene)) {
			displayViewOnlyModal();
			return;
		}

		// The new chat is a client-only draft; it hits the server only once its first
		// message is sent.
		startSceneChatDraft();
	};

	return <ActionButton icon={IconType.CHAT_NEW} label="Start a fresh chat" onClick={onClick} />;
};

export default SceneNewChatAction;
